import { z } from 'zod';

export const ComposeComment = z.object({
    body: z.string().min(3, { message: 'حداقل کامنت باید ۱۰ کاراکتر باشد' }),
    rate: z
        .number()
        .optional()
        .refine((val) => val !== undefined && val > 0, {
            message: 'امتیاز الزامی است'
        })
});

// Types
export type ComposeCommentFormValues = z.infer<typeof ComposeComment>;

